<div class="settings component">
  <div class="tabs">
    @for (tab of tabsList; track trackByKey($index, tab)) {
    <div class="tabs-item" [ngClass]="{ active: selectedTab === tab.key }">
      <div class="label" (click)="changeTab(tab)">
        {{ tab.label }}
      </div>
      @for (subTabs of tab?.children; track trackByKey($index, subTabs)) {
      <div
        [hasViewPermission]="subTabs.permissions"
        [alignRight]="true"
        [iconExtraStyles]="{
          fill: '#C3C2C2',
          marginTop: '-38px',
          marginRight: '10px'
        }"
        [hostExtraStyles]="{ opacity: '0.5' }"
      >
        <div
          class="tabs-sub-item"
          [ngClass]="{ active: selectedTab === subTabs.key }"
        >
          <div class="label" (click)="changeTab(subTabs)">
            {{ subTabs.label }}
          </div>
        </div>
      </div>
      }
    </div>
    }
  </div>

  <div class="tabs-content">
    @switch (selectedTab) { @case (tabsKey.Units) {
    <firebird-web-units></firebird-web-units>
    } @case (tabsKey.Responsiveness) {
    <firebird-web-responsiveness></firebird-web-responsiveness>
    } @case (tabsKey.Favorite) {
    <firebird-web-favorite-locations></firebird-web-favorite-locations>
    } @case (tabsKey.Notifications) {
    <firebird-web-notifications></firebird-web-notifications>
    } @case (tabsKey.ApiServices) {
    <firebird-web-enhanced-data-services></firebird-web-enhanced-data-services>
    } @case (tabsKey.Mobile) {
    <firebird-web-mobile-app></firebird-web-mobile-app>
    } }
  </div>
</div>
